<h2 matDialogTitle>¿Eliminar?</h2>
<mat-dialog-content>
  <p>Una vez eliminado todos sus datos serán borrados. ¿Continuar?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button matDialogClose="cancel" color="primary">Cancel</button>
  <button mat-button matDialogClose="confirm" color="warn">Sí, eliminar</button>
</mat-dialog-actions>
